import { RowNode } from '@ag-grid-community/core'
import { Break } from '../model/break.model'

/**
 * Get the group category priority from a group row node
 */
export function getGroupCategoryPriority(node: RowNode): number {
  if (!node.hasChildren()) {
    return 0
  }

  const breakData = node.allLeafChildren[0].data as Break
  return breakData.categoryPriority ?? 0
}
